import { httpService } from '@mfe/app/services/http';
import { AxiosRequestConfig } from 'axios';
import decodeJWT, { JwtPayload } from 'jwt-decode';

import { getCookie } from './authHelpers';

interface RefreshJWTProps {
    refreshTokenUrl: string;
    accessTokenCookieKey: string;
}

interface AvivJWT extends JwtPayload {
    fully_authenticated: boolean;
}

function isTokenFullyAuthenticated(token: string): boolean {
    return decodeJWT<AvivJWT>(token).fully_authenticated;
}

export async function refreshJWT({
    refreshTokenUrl,
    accessTokenCookieKey,
}: RefreshJWTProps): Promise<void> {
    const requestOptions: AxiosRequestConfig = { withCredentials: true };
    const resp = await httpService.get(refreshTokenUrl, requestOptions);

    if (resp.status !== 200) {
        throw new Error('Token refresh request rejected');
    }

    const newAccessToken = getCookie(accessTokenCookieKey);

    if (!newAccessToken) {
        throw new Error('Updated access token is not found in cookies');
    }

    if (!isTokenFullyAuthenticated(newAccessToken)) {
        throw new Error('New auth token is not fully authenticated');
    }
}
